import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  getInstallationRequest,
  getInstallationById,
  editInstallation,
  createInstallation,
  deleteInstallationById,
  getSec,
} from '../../services/mm/apiController';
import { factoryId, loggedInUser } from '../../store/reducers/account_reducer';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table, Modal, Button, Form, FloatingLabel, Row, Col, Alert } from 'react-bootstrap';
import { formatDate } from '../../util/helper';
import { toast, ToastContainer } from 'react-toastify';
import { DeleteIcon, EditIcon, ViewIcon } from '../vm/components/icons';
import AlertIcon from '../../img.svg';
import { Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import FactoryDropdown from '../vm/FactoryDropdown';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import axios from 'axios';
import { getStoredData, get_auth_key } from '../../util';

const InstallationView = () => {
  let user = useSelector(loggedInUser);
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const factoryId_ = useSelector(factoryId);
  const [poNumber, setPoNumber] = useState('');
  const [sections, setSections] = useState([]);
  const [itemNumber, setItemNumber] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [insList, setInsList] = useState([]);
  const [show, setShow] = useState(false);
  const [idToDeleted, setIdToDeleted] = useState('');
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const [machineModelShow, setMachineModelShow] = useState(false);
  const formFields = {
    item: '',
    itemNumber: '',
    section: '',
    charges: '',
    description: '',
    installationDate: '',
    location: '',
    requestId: '',
    purchaseId: '',
    manual: null,
    userManual: '',
    isWarrantyAvailable: false,
    warrantyPeriod: '',
    technitionName: '',
    technitionContactNumber: '',
    status: 'INSTALLED',
    file1: null,
    file_1: null,
    file2: null,
    file_2: null,
    file3: null,
    file_3: null,
    file4: null,
    file_4: null,
    file5: null,
    file_5: null,
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const [purchaseOrderForm, setPurchaseOrderForm] = useState(formFields);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleMachineClose = () => {
    setMachineModelShow(false);
  };
  const handleCloseConfirmModal = () => {
    setShowConfirmModel(false);
  };

  const handleMachineModelShow = () => {
    setMachineModelShow(true);
    setPurchaseOrderForm(formFields);
  };

  const handleShow = (event, id) => {
    event.preventDefault();
    const getInstallationV = async () => {
      const installationVal = await getInstallationById(id);
      const hole = installationVal?.data;
      if (hole.installationDate !== null) hole.installationDate = moment(hole.installationDate).format('YYYY-MM-DD');
      if (hole.warrantyPeriod !== null) hole.warrantyPeriod = moment(hole.warrantyPeriod).format('YYYY-MM-DD');
      if (hole.warrantyPeriod !== null) hole.isWarrantyAvailable = true;
      hole.manual = null;
      hole.file1 = null;
      hole.file2 = null;
      hole.file3 = null;
      hole.file4 = null;
      hole.file5 = null;
      delete hole.PurchaseOrder;
      delete hole.MachineRequest;
      setPurchaseOrderForm(hole);
    };
    getInstallationV();
    setShow(true);
  };

  const handleShowConfirmModal = (e, id) => {
    e.preventDefault();
    setShowConfirmModel(true);
    setIdToDeleted(id);
  };

  const handleRemove = (event, id) => {
    event.preventDefault();
    const deleteInstallation = async () => {
      try {
        const data = await deleteInstallationById(id);
        toast.error(data.data);
        getInstal();
        setShowConfirmModel(false);
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
      }
    };
    deleteInstallation();
  };

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };

  const onChangeManual = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, manual: null, userManual: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, userManual: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const onChangeWarrantyDocument = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file1: null, file_1: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_1: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };
  const onChangeBill = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file2: null, file_2: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_2: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };
  const onChangeMachineImage1 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file3: null, file_3: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_3: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };
  const onChangeMachineImage2 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file4: null, file_4: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_4: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };
  const onChangeMachineImage3 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setPurchaseOrderForm({ ...purchaseOrderForm, file5: null, file_5: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, file_5: resp.data });
            toast.success('File uploaded successfully.');
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    if (purchaseOrderForm.id && purchaseOrderForm !== null) {
      try {
        if (
          !purchaseOrderForm.itemNumber ||
          !purchaseOrderForm.charges ||
          !purchaseOrderForm.installationDate ||
          !purchaseOrderForm.location
        ) {
          toast.error('Please fill in all the required fields.');
          return;
        }
        setIsButtonDisabled(false);
        await editInstallation(purchaseOrderForm, purchaseOrderForm.id);
        setShow(false);
        getInstal();
        toast.success('Installation updated successfully');
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 3000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        if (
          !purchaseOrderForm.item ||
          !purchaseOrderForm.section ||
          !purchaseOrderForm.itemNumber ||
          !purchaseOrderForm.charges ||
          !purchaseOrderForm.installationDate ||
          !purchaseOrderForm.location
        ) {
          toast.error('Please fill in all the required fields.');
          return;
        }
        await createInstallation(purchaseOrderForm);
        toast.success('Installation added successfully');
        setMachineModelShow(false);
        getInstal();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || err?.message || 'Something went wrong', { autoClose: 3000 });
      } finally {
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const getInstallationList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0, id = 0) => {
    try {
      let condition = {
        name: poNumber || '',
        itemNumber: itemNumber || '',
      };
      if (localStorage.factoryId) {
        condition['factoryId'] = await localStorage.factoryId;
      } else {
        return {};
      }
      const installation = await getInstallationRequest(offset - 1, limit, condition, id);
      return id === 0
        ? {
            data: (installation && installation.data.rows) || [],
            totalRecords: (installation && installation.data && installation.data.count) || 0,
          }
        : {
            data: (installation && installation.data) || [],
          };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getInstal();
      }
    },
    [poNumber, itemNumber],
    DEBOUNCE_DELAY
  );

  async function getInstal() {
    const data = await getInstallationList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(data.totalRecords);
    setInsList(data?.data);
  }

  async function getSections() {
    const data = await getSec(factoryId_);
    setSections(data.data);
  }

  useEffect(() => {
    getInstal();
  }, [currentPage]);

  useEffect(() => {
    getSections();
  }, [factoryId_]);

  const handleToggle = (e) => {
    const { checked } = e.target;
    setPurchaseOrderForm({ ...purchaseOrderForm, isWarrantyAvailable: checked });
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="">Installation List</a>
          </li>
        </ol>
      </nav>
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <FactoryDropdown onFactoryChange={getInstal} />
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">Machine Name</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Please enter Machine Name"
                value={poNumber}
                onChange={(e) => setPoNumber(e.target.value)}
              />
            </div>
            <div className="form-group col-md-2 col-lg-2">
              <label htmlFor="exampleInputEmail1">Item / Asset Number</label>
              <input
                type="text"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Please enter Item / Asset Number"
                value={itemNumber}
                onChange={(e) => setItemNumber(e.target.value)}
              />
            </div>
            <div className="form-group col-md-2 col-lg-2">
              <div className="btn-wrapper justify-content-start cmt-3">
                <button
                  type="button"
                  className="btn app-btn-default"
                  onClick={(e) => {
                    setPoNumber('');
                    setItemNumber('');
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          {factoryId_ ? (
            <>
              <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                Installation | {totalRecords ?? 0}
              </h4>
              <button type="button" className="btn app-btn-default dark-color" onClick={handleMachineModelShow}>
                Create
              </button>
            </>
          ) : (
            <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
              Please Select a Factory
            </h4>
          )}
        </div>
        {factoryId_ && totalRecords > 0 ? (
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped>
                  <thead>
                    <tr>
                      <th>Item/Asset #</th>
                      <th>Machine Name</th>
                      <th>Section</th>
                      <th>Charges</th>
                      <th>Approved By</th>
                      <th>Installation Date</th>
                      <th>Created Date</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {insList?.map((request, index) => {
                      return (
                        <tr key={request.id} className={request.status === 'SCRAP-RESELL' ? 'resell-scrap' : ''}>
                          <td>{request.itemNumber}</td>
                          <td>{!request.MachineRequestId ? request.item : request?.MachineRequest?.model}</td>
                          <td>{request.section}</td>
                          <td>₹{request.charges}</td>
                          <td>{request.purchase_order?.initiatedBy}</td>
                          <td>{formatDate(request.installationDate)}</td>
                          <td>{formatDate(request.createdAt)}</td>
                          <td className="actions">
                            {request.isDeleted === true ? (
                              ''
                            ) : (
                              <Link to={`/mm/installation/${request.id}`}>
                                <ViewIcon />
                              </Link>
                            )}
                            &nbsp;&nbsp;
                            {request.isDeleted === true ? (
                              ''
                            ) : (
                              <span onClick={(e) => handleShow(e, request.id)} className="edit-icon">
                                <EditIcon />
                              </span>
                            )}
                            &nbsp;&nbsp;
                            {request.status !== 'HIDDEN' ? (
                              <Link to="/" className="delete" onClick={(e) => handleShowConfirmModal(e, request.id)}>
                                <DeleteIcon />
                              </Link>
                            ) : (
                              ''
                            )}
                            {'  '}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <PaginationInPage
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalRecords={totalRecords}
                  TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            {factoryId_ ? (
              <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
                  No Data Available
                </h4>
              </div>
            ) : (
              ''
            )}
          </>
        )}
      </div>
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Edit Installation</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                  <Form.Control
                    value={purchaseOrderForm.item}
                    className="input"
                    name="item"
                    type="text"
                    placeholder="Machine Name"
                    required
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Section" className="mb-3">
                  <Form.Select
                    value={purchaseOrderForm.section}
                    onChange={handleChange}
                    name="section"
                    aria-label="Floating label select example"
                    required
                    readOnly
                  >
                    <option>{purchaseOrderForm.section}</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Model Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.itemNumber}
                    className="input"
                    name="itemNumber"
                    type="text"
                    placeholder="Enter Model Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Additional Charges" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.charges}
                    className="input"
                    name="charges"
                    type="text"
                    placeholder="Enter Charges"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Installation Date" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.installationDate}
                    className="input"
                    name="installationDate"
                    type="date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Location" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.location}
                    className="input"
                    name="location"
                    type="text"
                    placeholder="Location"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">User Manual</Form.Label>
                  <Form.Control onChange={onChangeManual} type="file" name="manual" aria-required="false" />
                  <p>{purchaseOrderForm.userManual}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Warranty</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={5} className="warranty-btn mt-3">
                <span>Is Warranty Available?</span>
                <input
                  className="react-switch-checkbox"
                  id={`react-switch-new`}
                  type="checkbox"
                  onChange={handleToggle}
                  checked={purchaseOrderForm.isWarrantyAvailable}
                  name="isWarrantyAvailable"
                />
                <label className="react-switch-label" htmlFor={`react-switch-new`}>
                  <span className="no">NO</span>
                  <span className={`react-switch-button`} />
                  <span className="yes">YES</span>
                </label>
              </Col>
              {purchaseOrderForm.isWarrantyAvailable === true ? (
                <Col xs={4} className="mt-4">
                  <FloatingLabel controlId="floatingInput" label="Warranty Covered Till" className="mt-1">
                    <Form.Control
                      onChange={handleChange}
                      value={purchaseOrderForm.warrantyPeriod}
                      className="input"
                      name="warrantyPeriod"
                      type="date"
                    />
                  </FloatingLabel>
                </Col>
              ) : (
                ''
              )}
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Technician details</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Technician Name">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.technitionName}
                    className="input"
                    name="technitionName"
                    type="text"
                    placeholder="Technician Name"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Technician Mobile">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.technitionContactNumber}
                    className="input"
                    name="technitionContactNumber"
                    type="text"
                    placeholder="Technician Mobile"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Documents</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 1</Form.Label>
                  <Form.Control onChange={onChangeWarrantyDocument} type="file" name="file_1" aria-required="false" />
                  <p>{purchaseOrderForm.file_1}</p>
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 2</Form.Label>
                  <Form.Control onChange={onChangeBill} type="file" name="file_2" aria-required="false" />
                  <p>{purchaseOrderForm.file_2}</p>
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 3</Form.Label>
                  <Form.Control onChange={onChangeMachineImage1} type="file" name="file_3" aria-required="false" />
                  <p>{purchaseOrderForm.file_3}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 4</Form.Label>
                  <Form.Control onChange={onChangeMachineImage2} type="file" name="file_4" aria-required="false" />
                  <p>{purchaseOrderForm.file_4}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 5</Form.Label>
                  <Form.Control onChange={onChangeMachineImage3} type="file" name="file_5" aria-required="false" />
                  <p>{purchaseOrderForm.file_5}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Update
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal size="lg" show={machineModelShow} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Installation</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleMachineClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.item}
                    className="input"
                    name="item"
                    type="text"
                    placeholder="Machine Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Section" className="mb-3">
                  <Form.Select
                    value={purchaseOrderForm.section}
                    onChange={handleChange}
                    name="section"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Section</option>
                    {Object.keys(sections).map((key) => (
                      <option key={key} value={key.value}>
                        {sections[key].value}
                      </option>
                    ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Model Number" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.itemNumber}
                    className="input"
                    name="itemNumber"
                    type="text"
                    placeholder="Enter Model Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Additional Charges" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.charges}
                    className="input"
                    name="charges"
                    type="text"
                    placeholder="Enter Charges"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Installation Date" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.installationDate}
                    className="input"
                    name="installationDate"
                    type="date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Location" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.location}
                    className="input"
                    name="location"
                    type="text"
                    placeholder="Location"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">User Manual</Form.Label>
                  <Form.Control onChange={onChangeManual} type="file" name="manual" aria-required="false" />
                  <p>{purchaseOrderForm.userManual}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Warranty</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={5} className="warranty-btn mt-3">
                <span>Is Warranty Available?</span>
                <input
                  className="react-switch-checkbox"
                  id={`react-switch-new`}
                  type="checkbox"
                  onChange={handleToggle}
                  checked={purchaseOrderForm.isWarrantyAvailable}
                  name="isWarrantyAvailable"
                />
                <label className="react-switch-label" htmlFor={`react-switch-new`}>
                  <span className="no">NO</span>
                  <span className={`react-switch-button`} />
                  <span className="yes">YES</span>
                </label>
              </Col>
              {purchaseOrderForm.isWarrantyAvailable === true ? (
                <Col xs={4} className="mt-4">
                  <FloatingLabel controlId="floatingInput" label="Warranty Covered Till" className="mt-1">
                    <Form.Control
                      onChange={handleChange}
                      value={purchaseOrderForm.warrantyPeriod}
                      className="input"
                      name="warrantyPeriod"
                      type="date"
                    />
                  </FloatingLabel>
                </Col>
              ) : (
                ''
              )}
            </Row>
            <Row className="mb-4">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Technician details</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Technician Name">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.technitionName}
                    className="input"
                    name="technitionName"
                    type="text"
                    placeholder="Technician Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4} className="mt-4">
                <FloatingLabel controlId="floatingInput" label="Technician Mobile">
                  <Form.Control
                    onChange={handleChange}
                    value={purchaseOrderForm.technitionContactNumber}
                    className="input"
                    name="technitionContactNumber"
                    type="text"
                    placeholder="Technician Mobile"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} className="blockLine my-3">
                <p className="my-0">
                  <strong>Documents</strong>
                </p>
                <hr className="my-0" />
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 1</Form.Label>
                  <Form.Control onChange={onChangeWarrantyDocument} type="file" name="file1" aria-required="false" />
                  <p>{purchaseOrderForm.file_1}</p>
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 2</Form.Label>
                  <Form.Control onChange={onChangeBill} type="file" name="file2" aria-required="false" />
                  <p>{purchaseOrderForm.file_2}</p>
                </Form.Group>
              </Col>
              <Col xs={4} className="mt-4">
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 3</Form.Label>
                  <Form.Control onChange={onChangeMachineImage1} type="file" name="file3" aria-required="false" />
                  <p>{purchaseOrderForm.file_3}</p>
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 4</Form.Label>
                  <Form.Control onChange={onChangeMachineImage2} type="file" name="file4" aria-required="false" />
                  <p>{purchaseOrderForm.file_4}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label className="label-text">Document 5</Form.Label>
                  <Form.Control onChange={onChangeMachineImage3} type="file" name="file5" aria-required="false" />
                  <p>{purchaseOrderForm.file_5}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit" onClick={handleSubmit} className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Purchase Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemove(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default InstallationView;
